import { ConfigFilterItem, ConfigItem } from 'Core/interfaces/filters'

import { TaxRate } from './TaxCategory'

export enum StateProvinceSearchFields {
	searchById = 'searchById',
	searchByName = 'searchByStateName',
	searchByAbbrevation = 'searchByStateAbbrevation'
}

export enum StateProvinceFilterFields {
	countryCodeId = 'countryId'
}

export declare namespace StateProvince {
	interface Basic {
		id: number
		stateAbbreviation: string
		stateName: string
		country: string
	}

	interface State {
		code: string
		countryCode: string
		id: number
		name: string
		region: string
	}

	interface Detailed {
		id: number
		stateAbbreviation: string
		stateName: string
		country: Entity
		combinedNetTax: boolean
		taxNexus: boolean
		taxRates: TaxRate.Detailed[]
		taxCategories: TaxRate.TaxCategory.Detailed[]
	}

	namespace Form {
		interface Generic {
			stateAbbreviation: BasicString
			stateName: BasicString
			countryId: number | null
			combinedNetTax: boolean
			taxNexus: boolean
			taxRates: TaxRate.Form.Generic[]
		}
	}

	namespace Request {
		interface Generic {
			stateAbbreviation: BasicString
			stateName: BasicString
			countryId: number | null
			combinedNetTax: boolean
			taxNexus: boolean
			taxRates: TaxRate.Request.Generic[]
		}
	}

	namespace Search {
		interface Result {
			[StateProvinceSearchFields.searchById]: Entity[]
			[StateProvinceSearchFields.searchByName]: Entity[]
			[StateProvinceSearchFields.searchByAbbrevation]: Entity[]
		}

		interface Config {
			[StateProvinceSearchFields.searchById]: ConfigItem<StateProvinceSearchFields>
			[StateProvinceSearchFields.searchByName]: ConfigItem<StateProvinceSearchFields>
			[StateProvinceSearchFields.searchByAbbrevation]: ConfigItem<StateProvinceSearchFields>
		}
	}
	namespace Filter {
		interface Config {
			[StateProvinceFilterFields.countryCodeId]: ConfigFilterItem<string, string>
		}
	}
}
